import React from 'react';

import style from './QuoteBanner.module.scss';
import QuoteIcon from '../tour/assets/QuotationMark_Red';

import Observer from 'react-intersection-observer';

const QuoteBanner = ({ body, image, attribution, isQuote = true }) => {
  return (
    <Observer className={style.quoteBanner} threshold={0.65} triggerOnce={true}>
      {inview => (
        <React.Fragment>
          {image && (
            <img
              src={image.url}
              alt={image.alt}
              className={`${inview ? style.fadeIn : ''} ${style.quoteImage}`}
            />
          )}
          <div className={`${inview ? style.fadeInUp : ''} ${style.quoteText}`}>
            {body &&
              isQuote && (
                <div className={style.quoteIcon}>
                  <QuoteIcon />
                </div>
              )}
            {body && <h4 dangerouslySetInnerHTML={{ __html: body }} />}
            {attribution && isQuote && <p>{attribution}</p>}
          </div>
        </React.Fragment>
      )}
    </Observer>
  );
};

export default QuoteBanner;



// WEBPACK FOOTER //
// ./src/components/timeline/QuoteBanner.js